import { getDictItems,getSysConfig } from '@/api'

export default {
	state: {
    dict:{},
    sysconfig:{
			article:{},
			cms:{},
			login:{}
		},
	},
	mutations: {
	},
	actions: {
    async getDictItems({state},code){
      console.log(state,code,'----dict')
      state.dict[code] = await getDictItems(code.code)
      return state.dict[code]
    },
    async getSysConfig({state},code){
      state.sysconfig[code] = await getSysConfig(code)
      return state.sysconfig[code]
    }
	}
}
